import React from 'react';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    size?: number;
};

const ArrowLeftIcon = ({
    color = 'currentColor',
    size = 24,
    strokeWidth = 2,
    strokeLinecap = 'round',
    strokeLinejoin = 'round',
    ...props
}: Props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={size} height={size} {...props}>
        <path stroke={color} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} strokeWidth={strokeWidth} d="M19 12H5m7-7-7 7 7 7" />
    </svg>
);
export { ArrowLeftIcon };
